import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取文章管理数据列表（#253）
 */
export function getArticleList(data) {
  return request("".concat(BASE_URL) + "/article/list", METHOD.GET, data);
}

/**获取文章信息数据（#258）
 * @param {Object} id
 */
export function getArticleDetail(id) {
  return request("".concat(BASE_URL) + "/article/" + id, METHOD.GET);
}

/** 编辑文章信息数据（#259）
 * @param {Object} data
 */
export function updateArticle(data) {
  return request("".concat(BASE_URL) + "/article", METHOD.PUT, data);
}

/** 新增文章信息数据（#256）
 * @param {Object} data
 */
export function addArticle(data) {
  return request("".concat(BASE_URL) + "/article", METHOD.POST, data);
}

/** 更新文章状态数据（#254）
 * @param {Object} data
 */
export function updateArticleStatus(data) {
  return request("".concat(BASE_URL) + "/article/status", METHOD.PUT, data);
}

/** 删除文章信息数据（#255）
 * @param {Object} id
 */
export function deleteArticle(id) {
  return request("".concat(BASE_URL) + "/article/" + id, METHOD.DELETE);
}